import React, { useState } from 'react';
import FormBr from '../components/FormBr';
import FormEn from '../components/FormEn.js';
import FormSp from '../components/FormSp.js';
// import FormEmpty from '../components/FormEmpty';

export default function Home () {
    const [language, setLanguage] = useState('none');

    const handlePt = () => {
        setLanguage('pt');
    }

    const handleUs = () => {
        setLanguage('en');
    }

    const handleSp = () => {
        setLanguage('sp');
    }

    return (
        language === 'none' ?
            <div className='container mt-5'>
                <div className="row align-items-center justify-content-center">
                        <button className='btn btn-outline-secondary btn-lg btn-block mb-3' onClick={handlePt}> FORMULÁRIO EM PORTUGUÊS </button>
                        {/* Empty Form only below infomation*/}
                        <button className='btn btn-outline-secondary btn-lg btn-block mb-3' onClick={handleUs}> ENGLISH FORM </button>
                        <button className='btn btn-outline-secondary btn-lg btn-block mb-3' onClick={handleSp}> FORMULARIO EN ESPAÑOL </button>
                </div>
                <footer className="footer navbar-fixed-bottom">
                    { language === 'pt' ?
                        <span>Criado por <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.i9acao.com.br'>i9Ação</a> para <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.daimlertruck.com/'>Daimler Truck</a></span> :
                        language === 'en' || language === 'none' ?
                            <span>Created by <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.i9acao.com.br'>i9Ação</a> to <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.daimlertruck.com/'>Daimler Truck</a></span> :
                            <span>Creado por <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.i9acao.com.br'>i9Ação</a> para <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.daimlertruck.com/'> Daimler Truck</a></span>
                    }
                </footer>
            </div>
        : 
            <div className='container mt-5'>
                <div className='container mb-3'>
                    <div className="dropdown">
                        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            {language === 'pt' ? 'OPÇÕES DE FORMULÁRIO' : language === 'en' ? 'FORM OPTIONS' : 'OPCIONES DE FORMULARIO'}
                            {/* Empty Form only below infomation*/}
                            {/* {language === 'en' ? 'FORM OPTIONS' : 'OPCIONES DE FORMULARIO'} */}
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><span className="dropdown-item" onClick={handlePt}>FORMULÁRIO EM PORTUGUÊS</span></li>
                            {/* Empty Form only below infomation*/}
                            <li><span className="dropdown-item" onClick={handleUs}>ENGLISH FORM</span></li>
                            <li><span className="dropdown-item" onClick={handleSp}>FORMULARIO EN ESPAÑOL</span></li>
                        </ul>
                    </div>
                </div>
                {
                    language === 'pt' ? <FormBr /> : language === 'en' ? <FormEn /> : <FormSp />
                    
                    // Empty Form
                    // <FormEmpty language={language} empty='true'/>
                }
                <footer className="footer navbar-fixed-bottom">
                    { language === 'pt' ?
                        <span>Criado por <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.i9acao.com.br'>i9Ação</a> para <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.daimlertruck.com/'>Daimler Truck</a></span> :
                        language === 'en' ?
                            <span>Created by <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.i9acao.com.br'>i9Ação</a> to <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.daimlertruck.com/'>Daimler Truck</a></span> :
                            <span>Creado por <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.i9acao.com.br'>i9Ação</a> para <a style={{'color': 'white', 'textDecorationStyle': 'none'}} href='https://www.daimlertruck.com/'> Daimler Truck</a></span>
                    }
                </footer>
            </div>
    )
}